import { api } from "./connection/api";

const HMRC_ENDPOINT_PREFIX = "hmrc-integrations";

export const hmrcApi = api.injectEndpoints({
    endpoints: builder => ({
        initiateHMRCLogin: builder.mutation<{ authUrl: string }, { utr: string; documentId: string }>({
            query: ({ utr, documentId }) => ({
                url: `${HMRC_ENDPOINT_PREFIX}/start-auth`,
                method: "POST",
                body: { utr, documentId },
            }),
        }),
        fetchStoredEmploymentData: builder.query<any, { utr: string; documentId: string }>({
            query: ({ utr, documentId }) => ({
                url: `${HMRC_ENDPOINT_PREFIX}/employment-data?utr=${utr}&documentId=${documentId}`,
                method: "GET",
            }),
        }),
        deleteEmploymentData: builder.mutation<any, { documentId: string; employerName: string }>({
            query: ({ documentId, employerName }) => ({
                url: `${HMRC_ENDPOINT_PREFIX}/employment-data`,
                method: "DELETE",
                params: {
                    documentId,
                    employerName,
                },
            }),
        }),
    }),
});

export const {
    useInitiateHMRCLoginMutation,
    useDeleteEmploymentDataMutation,
    useFetchStoredEmploymentDataQuery,
} = hmrcApi;
